import { useDispatch } from 'react-redux';
import React, { useEffect } from 'react';
import { SaveAndContinue } from '../../components/SaveAndContinue/SaveAndContinue';
import {
  getDataStorageData,
  getIsDataStorageDataLoading,
  getRequestInfoType,
  getSession,
  getTransactionStatus
} from '../../redux/slices/appData/app-data.selectors';
import { routeByStatus, routes } from '../../routes';
import { useNavigate } from 'react-router-dom';
import { fetchDataStorageData } from '../../redux/slices/appData/app-data.actions';
import { ContentSection, Spinner } from '@vwfs-bronson/bronson-react';
import { TransactionStatus } from '../../models/data-storage.model';
import { useAppSelector } from '../../redux/store';
import { setSession } from '../../redux/slices/appData/app-data.slice';

type WithDataLoadedProps = {
  permittedStatuses?: TransactionStatus[];
  children: JSX.Element;
};

export const WithDataLoaded = (props: WithDataLoadedProps): JSX.Element => {
  const { children, permittedStatuses } = props;
  const navigate = useNavigate();

  const isDataStorageDataLoading = useAppSelector(getIsDataStorageDataLoading);
  const dataStorageData = useAppSelector(getDataStorageData);
  const transactionStatus = useAppSelector(getTransactionStatus);
  const requestInfoType = useAppSelector(getRequestInfoType);
  const appError = useAppSelector(state => state.appData.appError);
  const session = useAppSelector(getSession);

  const dispatch = useDispatch();

  useEffect(() => {
    if (permittedStatuses?.length && transactionStatus) {
      if (!permittedStatuses.includes(transactionStatus)) {
        navigate(routeByStatus(transactionStatus, { requestInfoType }));
      }
    }
  }, [permittedStatuses, transactionStatus]);

  useEffect(() => {
    if (session?.token) {
      dispatch(
        fetchDataStorageData({
          storefrontId: session.id,
          token: session.token,
          navigate
        })
      );
    }
  }, [session]);

  useEffect(() => {
    if (appError) {
      navigate(routes.error);
    }
  }, [appError]);

  useEffect(() => {
    if (!session) {
      const query = new URLSearchParams(location.search);
      const id = query.get('id') as string;
      const token = query.get('token') as string;
      if (id && token) {
        dispatch(setSession({ id, token }));
      } else if (id) {
        dispatch(setSession({ id, token: null }));
      } else {
        if (!session) {
          navigate(routes.error);
        }
      }
    }
  }, []);

  return (
    <>
      {session?.id && !session?.token && <SaveAndContinue />}
      {session?.token && (
        <>
          {dataStorageData && !isDataStorageDataLoading ? (
            children
          ) : (
            <ContentSection>
              <Spinner center />
            </ContentSection>
          )}
        </>
      )}
    </>
  );
};
